import type { VatRegistration } from "~/types/company";

export type VatVerificationStatus = VatRegistration["verificationStatus"];

interface VatVerificationPresentation {
	label: string;
	className: string;
}

export const VAT_VERIFICATION_PRESENTATION: Record<
	VatVerificationStatus,
	VatVerificationPresentation
> = {
	VERIFIED: {
		label: "Ověřeno v ADIS",
		className: "badge badge-soft badge-success",
	},
	STALE: {
		label: "Vyžaduje nové ověření",
		className: "badge badge-soft badge-warning",
	},
	DISPUTED: {
		label: "Údaje se prověřují",
		className: "badge badge-soft badge-warning",
	},
	QUARANTINED: {
		label: "Údaje nelze ověřit",
		className: "badge badge-soft badge-error",
	},
	HIDDEN: {
		label: "Stav ověření není dostupný",
		className: "badge badge-soft",
	},
};

export function getVatVerificationPresentation(vat: VatRegistration): VatVerificationPresentation {
	if (vat.isUnreliable && vat.verificationStatus === "VERIFIED") {
		return {
			label: "Nespolehlivý plátce",
			className: "badge badge-soft badge-error",
		};
	}

	return VAT_VERIFICATION_PRESENTATION[vat.verificationStatus];
}
